export default "__VITE_ASSET__DteIYY9S__"